<template>
    <div class="container">
        <div class="login">
            <div class="row">
                <div class="col-md-5">
                    <form @submit.prevent="login">
                        <div class="row">
                            <text-field label="Username" v-model="username" />
                        </div>
                        <div class="row">
                            <text-field label="Password" v-model="password" password />
                        </div>
                        <div class="row">
                            <div class="form-group">
                                <button class="ol-featured_button">Login</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextField from './primitives/TextField'
import toastr from 'toastr'
import { api } from '../framework/api';
import { store } from '../framework/store'

export default {
    components: { TextField },
    data() {
        return {
            username: null,
            password: null
        }
    },
    methods: {
        async login() {
            try {
                let result = await api.post(`auth`, { username: this.username, password: this.password });
                if(result.data.auth) {
                    store.init(result.data);
                    this.$router.push('/browse/reviewer');
                }
            }
            catch(err) {
                if(err.response.status == 401) {
                    store.clear();
                    toastr.error('Login failed');
                }
            }

        }
    },   
}
</script>

<style scoped>
    .login {
        position: relative;
        top: 60px; margin-left: 13px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue